import { forwardRef, useState } from 'react';
import Input from './Input';
import { ClosedEyeIcon, EyeIcon, LockIcon } from 'src/components/Icons/icons';
import type { IconComponent } from 'src/components/Icons/TextIcon';

export type PasswordInputProps = Omit<
    React.ComponentProps<typeof Input>,
    'type' | 'trailingIcon' | 'onTrailingClick'
> & {
    defaultVisible?: boolean;
    enableVisibilityToggle?: boolean;
    showIcon?: IconComponent;
    hideIcon?: IconComponent;
};

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
    (
        {
            defaultVisible = false,
            enableVisibilityToggle = true,
            showIcon = EyeIcon,
            hideIcon = ClosedEyeIcon,
            leadingIcon = LockIcon,
            ...props
        },
        ref,
    ) => {
        const [visible, setVisible] = useState(defaultVisible);
        const type = visible ? 'text' : 'password';
        const trailingIcon = enableVisibilityToggle
            ? visible
                ? showIcon
                : hideIcon
            : undefined;
        const onToggle = enableVisibilityToggle
            ? () => setVisible(prev => !prev)
            : undefined;

        return (
            <Input
                {...props}
                ref={ref}
                type={type}
                leadingIcon={leadingIcon}
                trailingIcon={trailingIcon}
                onTrailingClick={onToggle}
            />
        );
    },
);

PasswordInput.displayName = 'PasswordInput';
export default PasswordInput;
